import { CloudArrowDownIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Status } from "../../common/components/status";
import { classNames } from "../../common/utils/classnames";
import { IngestTaskFragment } from "../../graphql/generated";

const IngestTaskPic: React.FC<{
  task?: IngestTaskFragment;
  large?: boolean;
}> = ({ task, large }) => {
  const status = React.useMemo(() => {
    return Status.for(task);
  }, [task]);

  return (
    <CloudArrowDownIcon
      className={classNames(
        status.color.picClasses(),
        large ? "h-20 w-20" : "h-10 w-10",
        "rounded-full border-2"
      )}
    />
  );
};

export default IngestTaskPic;
